<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold">Nuevo artículo</label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
    tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <div style="text-align: inherit">
        <button (click)="guardar()" tabindex="16" type="button" class="btn btn-rounded btn-info m-b-15">
          <i class="fa fa-save"></i> Guardar
        </button>
        <button (click)="cancelar()" tabindex="17" (keydown.tab)="onNexFocus('nuevo')" type="button"
          class="btn btn-rounded btn-warning m-b-15">
          <i class="fa fa-times-circle"></i> Cancelar
        </button>
      </div>

      <div class="card">
        <div class="card-body">
          <div [hidden]="false">
            <div class="card-body">
              <!-- <h4 class="card-title"><b>Nuevo artículo</b></h4>


                            <hr> -->

              <div class="row">
                <div class="col-md-12">
                  <!--TIPO DE INVENTARIO-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Tipo de inventario:
                    </label>
                    <div class="col-sm-1" style="margin-left: -45px">
                      <input (keydown.enter)="retornarEnter($event)"
                        (keydown.enter)="onKeyEnterTipodeInventario($event)" (blur)="onBlurTipodeInventario($event)"
                        style="text-align: center" [(ngModel)]="objarticulo.tipinv" name="m" maxlength="2" type="text"
                        onkeypress="return event.charCode >= 8 && event.charCode <= 57" class="form-control tsiInput" />
                    </div>

                    <div class="col-sm-3">
                      <select id="cboTipoInventario" tabindex="1" [(ngModel)]="objarticulo.tipinv" name="moneda"
                        #selectTipoInventario class="col-sm-12 tsiSelect select_border">
                        <option *ngFor="let lst of tiposInventario" [value]="lst.tipinv">
                          {{ lst.tipinv + " - " + lst.dtipinv }}
                        </option>
                      </select>
                    </div>
                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                  </div>
                  <!--ARTICULO-->

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Artículo:
                    </label>
                    <div class="col-sm-2" style="margin-left: -45px">
                      <input type="text" class="form-control tsiInput" name="codart" [(ngModel)]="objarticulo.codart"
                        #codart maxlength="40" tabindex="2" placeholder="Código" />
                    </div>

                    <div class="col-sm-6">
                      <input type="text" class="form-control tsiInput" name="desarticulo"
                        [(ngModel)]="objarticulo.descri" #desarticulo maxlength="99" tabindex="3"
                        placeholder="Descripción" />
                    </div>
                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                  </div>

                  <!--UNIDAD DE MEDIDA-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Unidad de medida:</label>
                    <div class="col-sm-3" style="margin-left: -45px">
                      <select tabindex="4" class="col-sm-12  tsiSelect select_border"
                        [(ngModel)]="objarticulo.coduni" name="moneda"
                        (keydown.enter)="onKeyEnterUnidadesMedida($event)" (blur)="onBlurUnidadesMedida($event)"
                        id="cboUnidadesMedida" #selectunidadesMedidas>
                        <option *ngFor="let lst of unidadesMedidas" [value]="lst.coduni">
                          {{ lst.coduni + " - " + lst.desuni }}
                        </option>
                      </select>
                    </div>
                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>

                    <div class="col-sm-2" style=" margin-left: -17px">
                      <button data-bs-toggle="tooltip" title="Calcular: alt + 'C'" type="button" tabindex="32"
                        class="btn btn-light" (click)="generarCodigo()">
                        Generar código
                      </button>
                    </div>
                  </div>

                  <!--FECHA DE MATRICULA-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Fecha de matrícula:
                    </label>
                    <div class="col-sm-2" style="margin-left: -45px">
                      <input class="form-control" id="fechaMatricula" name="fechaMatricula"
                        [(ngModel)]="objarticulo.fmatri" type="date" max="2999-01-01" tabindex="5"
                        style="text-align: center !important" class="form-control tsiInput" />
                    </div>
                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                  </div>

                  <!--CONTROL DE STOCK-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Control de stock:
                    </label>
                    <div class="col-sm-4" style="margin-left: -45px">
                      <select class="col-sm-12  tsiSelect select_border"
                        [(ngModel)]="objarticulo.consto" name="consto" tabindex="6">
                        <option *ngFor="let lst of tipoControlStock" [value]="lst.tipo">
                          {{ lst.tipo + " - " + lst.descripcion }}
                        </option>
                      </select>

                      <!-- <input (keydown.enter)="retornarEnter($event)" class="form-control tsiInput" #inputControlStock
                        id="controlStock" name="controlStock" [(ngModel)]="objarticulo.consto"
                        (keyup)="keyUpControlStock(inputControlStock.value)"
                        (change)="keyUpControlStock(inputControlStock.value)" style="text-align: center !important;"
                        width="30px" type="number" max="8" min="0" tabindex="6"> -->
                    </div>
                  </div>

                  <!--FACTOR DE CONVERSION-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Factor conversión:
                    </label>
                    <div class="col-sm-2" style="margin-left: -45px">
                      <input (keydown.enter)="retornarEnter($event)" class="form-control tsiInput" id="factorConversion"
                        name="factorConversion" #factorVal (blur)="
                          asignarDecimalesFacConversion(objarticulo.faccon)
                        " [(ngModel)]="objarticulo.faccon" style="text-transform: uppercase; border-color: gray"
                        tabindex="7" onkeypress="return event.charCode >= 8 && event.charCode <= 57" maxlength="5" />
                    </div>
                    <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                  </div>

                  <!--CHECKBOX-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 text-left control-label">
                    </label>
                    <div class="form-group row col-sm-2" style="margin-left: -25px">
                      <input type="checkbox" class="form-check-input m-l-3" id="exampleCheck1" [(ngModel)]="inputAgrupa"
                        name="activo" tabindex="8" />
                      <label class="tsiLabel form-check-label m-t-5" for="exampleCheck1">Agrupa</label>
                    </div>
                    <div class="form-group row d-flex col-sm-3" style="margin-left: 2em">
                      <input type="checkbox" class="form-check-input m-l-3" id="exampleCheck2"
                        [(ngModel)]="inputPagoAdelantado" name="activo" tabindex="9" />
                      <label class="tsiLabel form-check-label m-t-5" for="exampleCheck2">Obliga pago adelantado</label>
                    </div>
                  </div>

                  <!--CODIGO DE BARRA-->
                  <div class="form-group row d-flex align-items-center" style="margin-top: -10px; margin-bottom: 0;">

                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Código de barra:
                    </label>
                    <div class="col-sm-5" style="margin-left: -45px">
                      <input data-original-title="Máximo 40 carácteres" data-toggle="tooltip"
                        (keydown.enter)="retornarEnter($event)" tabindex="10" class="form-control form-control-sm"
                        id="codBarra" name="codBarra" [(ngModel)]="objarticulo.codbar" type="text"
                        class="form-control tsiInput" maxlength="30" />
                    </div>
                  </div>

                  <!--COMENTARIO Y APLICACION -->
                  <!-- <div class="form-group row mb-1" style="margin-bottom: 0px;">
                                        <label for="fname2"
                                            class="col-md-3 text-left control-label">Comentario/Aplicación:
                                        </label>
                                        <div class="input-group col-sm-8" style="margin-left: -45px;">
                                            <textarea type="text" data-original-title="Máximo 249 carácteres"
                                                data-toggle="tooltip" (keydown.enter)="retornarEnter($event)"
                                                class="form-control form-control-sm" id="comentarioApp" name="comentarioApp"
                                                [(ngModel)]="objarticulo.wglosa"
                                                class="form-control tsiInput" tabindex="11" maxlength="250"></textarea>
                                        </div>
                                    </div> -->

                  <!--PROVEEDOR-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Proveedor:
                    </label>

                    <div class="col-sm-2" style="margin-left: -45px">
                      <input id="inputinterlocutorcodigo" type="text" class="form-control tsiInput"
                        name="desInterlocutor" [(ngModel)]="objarticulo.codprv" [disabled]="disabledProveedor"
                        tabindex="12" (keydown.enter)="onKeyEnterCodProveedor($event)" placeholder="Código"
                        maxlength="15" />
                    </div>

                    <div class="col-sm-6">
                      <input id="inputinterlocutornombre" type="text" class="form-control tsiInput"
                        name="codInterlocutor" [(ngModel)]="desProveedor" [disabled]="disabledProveedor" tabindex="13"
                        maxlength="40" #provee (keydown.enter)="onKeyEnterProveedor($event)"
                        placeholder="Ingresar Proveedor..." />
                    </div>

                    <div class="col-sm-1">
                      <button *ngIf="buscarProveedor == 'buscar'" class="btn btn-primary btn-sm boton"
                        (click)="openModalProveedor()" type="button" tabindex="14"
                        style="margin-left: -20px !important">
                        <i class="fa fa-search"></i>
                      </button>
                      <button *ngIf="buscarProveedor == 'borrar'" class="btn btn-primary btn-sm boton"
                        (click)="borrarDatosProveedor()" type="button" tabindex="14"
                        style="margin-left: -20px !important">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>

                  <!--CODIGO DE FABRICANTE-->
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Código de fabricante/marca:
                    </label>
                    <div class="col-sm-4" style="margin-left: -45px">
                      <input (keydown.enter)="retornarEnter($event)" class="form-control form-control-sm"
                        id="codFabricante" name="codFabricante" [(ngModel)]="objarticulo.proart" type="text"
                        class="form-control tsiInput" tabindex="15" maxlength="30" #codFabri />
                    </div>
                  </div>

                  <!--CODIGO DE FABRICANTE-->
                  <div class="form-group row d-flex align-items-center">
                    <label for="fname2" class="col-md-3 label-size tsiLabel mt-2">Código OEM:
                    </label>
                    <div class="col-sm-4" style="margin-left: -45px">
                      <input class="form-control form-control-sm" id="codoem" name="codoem"
                        [(ngModel)]="objarticulo.codoem" type="text" class="form-control tsiInput" tabindex="15"
                        maxlength="50" />
                    </div>
                  </div>

                  <div class="form-group row d-flex" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-3 label-size tsiLabel">Comentario/Aplicación:
                    </label>
                    <div class="col-md-5 input-group" style="margin-left: -45px">
                      <textarea class="form-control form-control-sm" rows="6" name="glosa" maxlength="240"
                        [(ngModel)]="objarticulo.wglosa" style="border-color: gray" tabindex="220"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>